import useWindowSize from '../../../hooks/useWindowSize';
import { DatePicker } from '@material-ui/pickers';
import { IconButton, InputAdornment } from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField';
import ClearIcon from '@material-ui/icons/Clear';
import { FormDatePickerProps } from 'core/types/formDatePicker';
import { APP_LUX_DATE_FORMAT } from 'core/utils/datesHelper';
import { DatePickerView } from '@material-ui/pickers/DatePicker/DatePicker';

/**
 * Material UI date picker, should be called only within FormContainer wrapper, that provides required context
 * @param classes
 * @param label
 * @param value
 * @param onChange
 * @param minDate
 * @param maxDate
 * @param clearable
 * @param isRequired
 * @param isDisabled
 * @param variant
 * @param format
 * @param disablePast
 * @param disableToolbar
 * @param helperText
 * @param hasError
 * @param openTo
 * @constructor
 */
const FormDatePicker = ({
    classes,
    label,
    value,
    onChange,
    minDate,
    maxDate,
    clearable,
    isRequired = false,
    isDisabled = false,
    variant = 'outlined',
    format = APP_LUX_DATE_FORMAT,
    disablePast = true,
    disableToolbar = false,
    helperText = '',
    hasError = false,
    openTo = 'date',
    name,
}: FormDatePickerProps): JSX.Element => {
    const { isMobileWidth } = useWindowSize();
    const datePickerVariant = isMobileWidth ? 'dialog' : 'inline';
    const showClear = Boolean(clearable && value);
    return (
        <DatePicker
            error={hasError}
            helperText={helperText}
            disabled={isDisabled}
            required={isRequired}
            disablePast={disablePast}
            className={classes}
            autoOk
            disableToolbar={disableToolbar}
            variant={datePickerVariant}
            inputVariant={variant as TextFieldProps['variant']}
            label={label}
            value={value}
            onChange={(date) => onChange(date)}
            InputProps={
                showClear
                    ? {
                          endAdornment: (
                              <InputAdornment position="end">
                                  <IconButton
                                      size="small"
                                      aria-label="clear date"
                                      onClick={(event) => {
                                          event.preventDefault();
                                          event.stopPropagation();
                                          onChange(null);
                                      }}
                                  >
                                      <ClearIcon fontSize="small" />
                                  </IconButton>
                              </InputAdornment>
                          ),
                      }
                    : undefined
            }
            format={format}
            minDate={!!minDate ? minDate : undefined}
            maxDate={!!maxDate ? maxDate : undefined}
            views={['year', 'month', 'date']}
            openTo={openTo as DatePickerView}
            name={name}
            role={'widget'}
        />
    );
};
export default FormDatePicker;
